<div class="device-item">
  <div class="device-item-data">
    <div class="device-item-infos">
      <div class="device-item-icons">
        @if (
          (device.isOk() && !isAssembleStep && !dissociation) ||
          (dissociation && device.isDissociated)
          ) {
          <img
            class="device-item-icon"
            src="assets/captor.svg"
            />
        }
        @if (
          (device.isKo() && !dissociation) ||
          (device.isOk() && isAssembleStep && !dissociation) ||
          (dissociation && !device.isDissociated)
          ) {
          <img
            class="device-item-icon"
            src="assets/captor_ko.svg"
            />
        }
      </div>
      <div class="device-id">
        <p class="device-item-txt">{{ id }}</p>
      </div>
    </div>
  </div>
  <div class="device-item-handle">
    <div class="device-item-actions"></div>
    @if (testEnabled && !device.isAssemble) {
      <button
        mat-stroked-button
        (click)="test()"
        class="device-item-test"
        >
        TEST
      </button>
    }
    @if (!device.isAssemble) {
      <button mat-icon-button (click)="delete()">
        <img class="device-item-icon" src="assets/delete_grey.svg" />
      </button>
    }
    @if (
      (device.isKo() && !dissociation) ||
      (device.isConfirm() && isAssembleStep && !dissociation)
      ) {
      <img
        class="device-item-icon"
        src="assets/captor_state_assemble.svg"
        />
    }
    @if (
      (device.isConfirm() && !isAssembleStep && !dissociation) ||
      (dissociation && device.isDissociated)
      ) {
      <img
        class="device-item-icon"
        src="assets/captor_state_confirmed.svg"
        />
    }
  </div>
</div>
<mat-divider></mat-divider>
